import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { VenueModelRequest, VenueModelResponse } from '../_models/Venue/VenueModel';

@Injectable({
  providedIn: 'root'
})
export class VenueService {

  venuesChanged = new Subject<VenueModelResponse[]>();
  private venues: VenueModelResponse[] = [];
  pageNumber: number;
  totalPages: number;
  constructor() { }

  getVenues() {
    return this.venues.slice();
  }
  getVenuesPageNumber() {
    return this.pageNumber;
  }
  getVenuesTotalPages() {
    return this.totalPages;
  }

  getVenue(index: number) {
    return this.venues[index];
  }

  addVenue(venue: VenueModelResponse) {
    this.venues.push(venue)
    this.venuesChanged.next(this.venues.slice());
  }

  setVenues(venues: VenueModelResponse[], pageNumber: number, totalPages: number) {
    this.pageNumber = pageNumber;
    this.totalPages = totalPages;
    if (pageNumber > 1) {
      this.venues = this.venues.concat(venues)
    }
    else {
      this.venues = venues;
    }
    this.venuesChanged.next(this.venues.slice());
  }

  deleteVenue(index: number) {
    this.venues.splice(index, 1);
    this.venuesChanged.next(this.venues.slice());
  }

  setVenueValues(venue: VenueModelRequest, isEdit: boolean) {
    const formData = new FormData();
    formData.append('Name', venue.Name as string)
    formData.append('Description', venue.Description as string)
    formData.append('Address', venue.Address as string)
    formData.append('FormatedAddress', venue.FormatedAddress as string)
    formData.append('City', venue.City as string)
    formData.append('PostalCode', venue.PostalCode as string)
    formData.append('CountryCode', venue.CountryCode as string)
    formData.append('MaximumCapacity', String(venue.MaximumCapacity))
    formData.append('GooglePlaceId', venue.GooglePlaceId as string)
    formData.append('WebsiteUrl', venue.WebsiteUrl as string)
    formData.append('Email', venue.Email as string)
    formData.append('Phone', venue.Phone as string)
    formData.append('Location.Latitude', String(venue.Latitude))
    formData.append('Location.Longitude', String(venue.Longitude))
    formData.append('SendLocationNotifications',String(venue.SendLocationNotifications))

    if (venue.BusinessTypesIds) {
      for (let i = 0; i < venue.BusinessTypesIds.length; i++) {
        formData.append("BusinessTypesIds", String(venue.BusinessTypesIds[i]))
      }
    }
    if (venue.HostsIds) {
      for (let i = 0; i < venue.HostsIds.length; i++) {
        formData.append("HostsIds", String(venue.HostsIds[i]))
      }
    }

    if (isEdit) {
      if (typeof venue.VenueImageFile === 'string') {
        //@ts-ignore
        formData.append('VenueImageFile', '')
      } else {
        //@ts-ignore
        formData.append('VenueImageFile', venue.VenueImageFile as string)
      }
    } else {
      formData.append('VenueImageFile', venue.VenueImageFile as string)
    }
    return formData;
  }
}
